module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-by.e896d1c2.png";